import type { RouteDefinition } from "../route-definition.ts";

export const productPlayRoutes = {
  play: {
    path: "/play",
    scope: "static",
    bucket: "app",
    entry: "workflow",
    disposition: "page",
  },
  legacyPlay: {
    path: "/play/*coworld",
    scope: "static",
    bucket: "app",
    entry: "compatibility",
    disposition: "resolver",
  },
  legacyPreview: {
    path: "/preview/*coworld",
    scope: "static",
    bucket: "app",
    entry: "compatibility",
    disposition: "resolver",
  },
  replay: {
    path: "/replays/:coworldId",
    scope: "static",
    bucket: "app",
    entry: "workflow",
    disposition: "page",
  },
  ideNext: {
    path: "/ide-next/*path?",
    scope: "static",
    bucket: "app",
    entry: "workflow",
    disposition: "page",
  },
  retiredIdeFinal: {
    path: "/ide-final/*path?",
    scope: "static",
    bucket: "app",
    entry: "direct",
    disposition: "retired",
  },
  retiredIde: {
    path: "/ide/*path?",
    scope: "static",
    bucket: "app",
    entry: "direct",
    disposition: "retired",
  },
  retiredIdeMvp: {
    path: "/ide-mvp/*path?",
    scope: "static",
    bucket: "app",
    entry: "direct",
    disposition: "retired",
  },
  retiredPaper: {
    path: "/paper/*path?",
    scope: "static",
    bucket: "app",
    entry: "direct",
    disposition: "retired",
  },
  robots: {
    path: "/robots.txt",
    scope: "static",
    bucket: "app",
    entry: "direct",
    disposition: "document",
  },
} as const satisfies Record<string, RouteDefinition>;
